var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.products),function(product){return _c('product-card',{key:product.id,staticClass:"mb-7",staticStyle:{"max-width":"1000px"},attrs:{"product":product}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }